<div class="card rounded p-3 mb-2 simple-prog-form-card">
  <div class="d-flex justify-content-between align-items-center">
    <div class="progressive-form-header-area">
      <h3 class="h4 my-0 d-flex align-items-center" wlCSCapture>
        {{ fields?.CardTitle.value }}
      </h3>
    </div>
  </div>
  <hr class="my-2" wlCSCapture />
  <div class="mb-2">
    <span *wlGenericRichText="fields?.CardContent"></span>
  </div>
  <div [ngbCollapse]="false" class="form-card-actions">
    <a
      class="btn btn-outline-primary me-md-2 mb-2 mb-md-0"
      [wlAutomationId]="automationId + '-redirect-button'"
      wlCSCapture
      *wlGenericLink="fields?.RedirectToMijnButton"
    ></a>
    <button
      type="button"
      class="btn btn-outline-primary"
      [wlAutomationId]="automationId + '-continue-button'"
      wlCSCapture
      (click)="continueAsNewCustomer.emit()"
    >
      {{ fields?.ContinueAsNewCustomerButtonText.value }}
      <fa-icon [icon]="fields?.submitButtonIcon ?? 'arrow-down'"></fa-icon>
    </button>
  </div>
</div>
